export const RESUME_UPLOAD_CONFIG = {
  SOFT_FILE_LIMIT: 50,
  HARD_FILE_LIMIT: 60,
  MAX_FILE_SIZE_MB: 10,
  MAX_TOTAL_SIZE_MB: 100,
  CHUNK_SIZE: 2,
  ACCEPTED_TYPES: {
    'application/pdf': '.pdf',
    'application/msword': '.doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
  },
  ACCEPTED_EXTENSIONS: ['.pdf', '.doc', '.docx'],
};
